export const SIDEBAR_ATTACHED_BREAKPOINT = 1440
export const CONTENT_ATTACHED_BREAKPOINT = 768
export const FAVICON_PATH = `${process.env.PUBLIC_URL}/favicon.png`
export const MESSAGES_PER_PAGE = 100
export const STARTER_MESSAGE = "/start"
export const DEFAULT_DIALOG_HISTORY_PAGE = 5
export const SHOW_LINKED_CLIENTS_KEY = "ShowLinkedClients"

export const MIN_RIGHT_SIDEBAR_WIDTH_PX = 0
export const RIGHT_SIDEBAR_COLLAPSE_BREAKPOINT_PX = 450
export const DEFAULT_RIGHT_SIDEBAR_WIDTH = 30

export const LEFT_SIDEBAR_SHORTCUT_WIDTH_PX = 72
export const LEFT_SIDEBAR_SHORTCUT_BREAKPOINT_PX = 320
export const DEFAULT_LEFT_SIDEBAR_WIDTH = 23

export const MIN_CENTER_WIDTH_PX = 500
export const LEFT_MENU_WIDTH_PX = 90
